import { css } from "@emotion/css";
import { theme } from "../../utils/theme";

export const userMessageContainerCSS = css`
  display: block;
  text-align: right;
  width: 100%;
  padding-top: 1rem;
  margin-bottom: 1rem;
  padding-left: 70px;
`;

export const userMessageCSS = css`
  border-radius: 24px;
  padding: 16px;
  background-color: ${theme.palette.gray[10]};
  display: inline-block;
  text-align: left;
`;
